import Enum from './enum'

class MessageTheme extends Enum
{
  constructor(value) {
    super(value);
  }
}

MessageTheme.init({
  EMPTY: 'None',
  OTHER: 'Other',
  QUESTION: 'Question',
  COMPLAINT: 'Complaint',
  SUGGESTION: 'Suggestion',
  REGISTRATION: 'Registration',
  MAKING_BID: 'MakeBid'
}, {
  EMPTY: 'message-theme.empty',
  OTHER: 'message-theme.other',
  QUESTION: 'message-theme.question',
  COMPLAINT: 'message-theme.complaint',
  SUGGESTION: 'message-theme.suggestion',
  REGISTRATION: 'message-theme.registration',
  MAKING_BID: 'message-theme.making-bid'
});

export default MessageTheme;
